import { User as Auth0User } from "@auth0/auth0-spa-js";
import { components } from "@certn/api/generated-schemas/client-portal";

export type Schemas = components["schemas"];

export type User = Auth0User;
export type UserDetails = Schemas["LoggedInUserDetail"];
export type ClientAccount = Schemas["LoggedInUserDetailClientAccount"];
export type CustomerGroup = Schemas["LoggedInUserDetailCustomerGroups"];
export type CustomerGroups = Schemas["LoggedInUserDetailCustomerGroups"][];
export type CaseCounts = Schemas["CaseCountResponse"];
export type ActiveComplete = "ACTIVE" | "COMPLETE";

export type Previous = {
  href: string;
  name?: string;
};

export type Subsidiary = components["schemas"]["SubsidiaryEnum"];
export const subsidiaries: Record<Subsidiary, Subsidiary> = {
  CERTN_CANADA: "CERTN_CANADA",
  CERTN_USA: "CERTN_USA",
  CREDENCE: "CREDENCE",
  INTERCHECK: "INTERCHECK",
} as const;

export type PaymentMethod = components["schemas"]["PaymentMethodEnum"];
export const paymentMethods: Record<PaymentMethod, PaymentMethod> = {
  CREDIT_CARD: "CREDIT_CARD",
  CHECK: "CHECK",
  BANK_TRANSFER: "BANK_TRANSFER",
} as const;

export type PayerOption = components["schemas"]["SourceEnum"];
export const payerOptions: Record<PayerOption, PayerOption> = {
  CLIENT: "CLIENT",
  APPLICANT: "APPLICANT",
} as const;
